import React, { useState } from "react";
import { useSelector } from "react-redux";

import { HTextarea, passParamsThrough } from "../../../validation/HForm";
import CharCount from "../CharCount/CharCount";
import { FIELD_TITLES } from "./ServiceInformation/constants";

const FormElementsAdd = (props) => {
  const { description, currentField, isServiceInfo, handleAdditionalChange = () => {} } = props;
  const { accessFeatures } = useSelector(({ user }) => user);
  const [values, setValues] = useState({
    otherInformation: description?.otherInformation || "",
    lackIdentifierDataReason: description?.lackIdentifierDataReason || "",
    description: description?.description || ""
  });
  const aimAndRelationshipFeature = accessFeatures['client.aim_and_relationship']

  const handleChange = (id, value) => {
    setValues((prev) => ({ ...prev, [id]: value }));
    handleAdditionalChange(id, value); 
  }
  
  const formFields = [
    {
      label: FIELD_TITLES.lackIdentifierDataReason,
      id: "lackIdentifierDataReason",
      name: isServiceInfo ? 'lackIdentifierDataReason' : "client.lackIdentifierDataReason",
      value: values.lackIdentifierDataReason,
      maxLengthCount: 1000
    },
    {
      label: aimAndRelationshipFeature ? `${FIELD_TITLES.otherInformation} (служебная информация)` : FIELD_TITLES.otherInformation,
      id: "otherInformation",
      name: isServiceInfo ? 'otherInformation' : "client.otherInformation",
      value: values.otherInformation,
      maxLengthCount: 3000
    },
    {
      label: FIELD_TITLES.description,
      id: "description",
      name: "client.description",
      value: values.description,
      maxLengthCount: 3000
    },
  ];
  const filteredFields = currentField
    ? formFields.filter((field) => field.id === currentField)
    : formFields.filter((field) => field.label !== FIELD_TITLES.description);
   
  return passParamsThrough(
    <div className="description align-end">
      {filteredFields.map(({ label, id, name, value, maxLengthCount }) => (
        <div key={id} className="form-element box">
          <label className="form-element-label" htmlFor={id}>
            {label}
          </label>
          <div className="form-element-data textarea">
            <HTextarea
              h="true"
              className="input"
              rows="4"
              cols="10"
              name={name}
              id={id}
              onChange={(e) => handleChange(id, e.target.value)}
              value={value}
            />
          </div>
          <CharCount value={value} maxLength={maxLengthCount} />
        </div>
      ))}
    </div>,
    props
  );
};

export default FormElementsAdd;
